/**
 * Internal state type for managing arrival and departure times.
 */
export type TInternalValue = {
  /** Arrival time in 12-hour format (e.g., "08:00 am") */
  arrival: string;
  /** Departure time in 12-hour format (e.g., "05:00 pm") */
  departure: string;
};

export enum ErrorType {
  ExceedsTimeLimit = 'EXCEEDS_TIME_LIMIT',
  IncorrectTimeOrder = 'INCORRECT_TIME_ORDER',
  UnlikelyShifts = 'UNLIKELY_SHIFTS',
}
